import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga'

import reducer from './Reducers';
import RootSaga from './Sagas';

const sagaMiddleware = createSagaMiddleware();

const store = createStore(
    reducer,
    composeWithDevTools(
        applyMiddleware(/*logger,*/ sagaMiddleware)   
    )
)

sagaMiddleware.run(RootSaga);

export const runAction = (action) => {
    store.dispatch({type: action});
}

export const getCurrentStoreData = () => {
    return store.getState();
}


export default store;
